import { Link, useNavigate } from "react-router-dom";
import Headline4 from "../../../components/headings/Headline4";
import Styles from "../styles.module.scss";
import AuthHead from "../AuthHead";
import AuthMedia from "../authMedia";
import { LoginForm } from "./loginForm";
import { Auth } from "aws-amplify";
import { useEffect, useState } from "react";
import { getCustomerForUserId } from "./services";
import mixpanelData, { viewedpageMixpanel } from "../../../utils/mixpanel";

Auth.configure({
    userPoolId: "ap-south-1_0GE8bPCY8",
    userPoolWebClientId: "qf4m3jr6abvr2i5opelhjsejg", // app client id
    //identityPoolId: "42efbd0d-8bcb-46a2-b028-0a8affe3bb63",
    region: "ap-south-1",
    oauth: {
      region: "ap-south-1",
      domain: "https://ellow-prod-provider.auth.ap-south-1.amazoncognito.com",
      scope: ["phone", "email", "openid", "aws.cognito.signin.user.admin", "profile"],
      redirectSignIn: "https://myleads.ellow.io/dashboard",
      redirectSignOut: "https://myleads.ellow.io/login",
      responseType: "code" // or 'token', note that REFRESH token will only be generated when the responseType is code
    }
  });

function Login() {
  
  const navigate = useNavigate();
  const[message, setMessage] = useState<string>()
  const[disabled, setDisabled] = useState<boolean>(false)

  useEffect(() => {
   viewedpageMixpanel()
  }, [])
  

  const onSubmit = (data: any) => {
    setDisabled(true)
    setMessage('')
    Auth.signIn(data.email, data.password).then(async (result: any) => { 
      const session = await Auth.currentSession();
      const accessToken = session.getIdToken().getJwtToken();   
      localStorage.setItem('Token', accessToken)
      getCustomerForUserId(result.attributes.sub).then((response) => {
        if (response && response.status === 1) {
          localStorage.setItem('loginId', result.attributes.sub)
          localStorage.setItem('customerId', response.data[0].customer_id)
          localStorage.setItem('customerMetdata', JSON.stringify(response.data[0].customer_metadata))
          localStorage.setItem('Email', result.attributes.email)
          navigate('/positions')
          mixpanelData('New ML - Provider Login', {
            'distinct_id': data.email,
            'email': data.email,
            'Company id': response.data[0].customer_id
          })
        }
      })
    })
    .catch(err => {
      setDisabled(false)
      setMessage(err.message)
    })
  }

  return (
    <section className="App">
      <div className={Styles.authWapper}>
        <div className={Styles.loginForm}>
          <AuthHead />
          <div className={Styles.alignCenter}>
            <aside className={Styles.loginSignupWapper}>
              <div className={Styles.head}><Headline4>Welcome to ellow.io!</Headline4></div>
               <p className={Styles.or}>Sign in with your account</p>
              <div className={Styles.loginWith}>
                <LoginForm ClickHandler={onSubmit} disabled={disabled}/>
                <div>
                  <p className="error-message">{message}</p>
                </div>
                <div className={Styles.alreadyRegistered}>Don’t have an ellow account? <Link to="/registration">Sign up</Link></div>
              </div>
            </aside>
          </div>
        </div>
        <AuthMedia />
      </div>
    </section>
  )
}

export default Login;
